module.exports = __webpack_public_path__ + "static/media/home_banner_welcome_pt.2980b8e2.svg";